// inside any admin page (users / transactions etc.)
import { Button, Dropdown, Menu } from "antd";
import { useExportData } from "../../Hooks/useExportData";

const ExportButton = ({ category, filters, fields }) => {
    const { handleExport, loading } = useExportData();

    const menu = (
        <Menu
            items={[
                {
                    key: "csv",
                    label: "Export CSV",
                    onClick: () =>
                        handleExport({ category, filters, fields, type: "csv" }),
                },
                {
                    key: "excel",
                    label: "Export Excel",
                    onClick: () =>
                        handleExport({ category, filters, fields, type: "excel" }),
                },
            ]}
        />
    );

    return (
        <Dropdown overlay={menu} trigger={["click"]}>
            <Button loading={loading}>Export</Button>
        </Dropdown>
    );
};

export default ExportButton;